import React from 'react';
import styled from 'styled-components';

const Ruler = ({ col }) => {
    const RulerWrapper = styled.div`
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    `;
    const Even = styled.div`
        padding-left: 5px;
        width: ${100 / col * 2}%;
        max-width: 200px;
        border-left: 1px solid ${props => props.theme.palette.blueGrey[200]};
    `;

    const Odd = styled.div`
        background-color: ${props => props.theme.palette.secondary[50]};
        padding-left: 5px;
        width: ${100 / col * 2}%;
        max-width: 200px;
        border-left: 1px solid ${props => props.theme.palette.blueGrey[200]};
    `;

    const buildItems = col => {
        const items = [];
        for (let i = 1; i < col * 2; i++) {
            if (i % 2) {
                items.push(<Odd key={i} >{i * 10}</Odd >);
            }
            else {
                items.push(<Even key={i} >{i * 10}</Even >);
            }
        }
        return items;
    };

    return (
        <RulerWrapper >
            <Even key={0} >cm</Even >
            {buildItems(col)}
        </RulerWrapper >
    );
};

export default Ruler;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/Ruler.js